import React from 'react';
import styled from 'styled-components';
import { Typography } from 'antd';
import { LinkProps as AntdLinkProps } from 'antd/lib/typography/Link';
import theme, { ColorNameType } from '../theme';

const { Link: AntdLink } = Typography;

export interface LinkProps extends AntdLinkProps {
  block?: boolean;
  textAlign?: 'left' | 'center' | 'right';
  color?: ColorNameType;
  underlineOnHover?: boolean;
  nowrap?: boolean;
}

const Link = React.forwardRef<HTMLLinkElement, LinkProps>(
  (
    {
      block,
      textAlign = 'left',
      color,
      underlineOnHover,
      nowrap = false,
      ...props
    },
    ref,
  ) => (
      <StyledLink
        ref={ref}
        $block={textAlign !== 'left' ? true : block}
        $textAlign={textAlign}
        $color={color}
        $underlineOnHover={underlineOnHover}
        $nowrap={nowrap}
        {...props}
      />
    ),
);

const StyledLink = styled(AntdLink)<{
  $textAlign: LinkProps['textAlign'];
  $block: LinkProps['block'];
  $color?: LinkProps['color'];
  $underlineOnHover?: LinkProps['underlineOnHover'];
  $nowrap?: LinkProps['nowrap'];
}>`
  && {
    text-align: ${({ $textAlign }) => $textAlign};
    ${({ $block }) => $block && `display: block`};
    ${({ $color }) =>
      $color &&
      `
      &, &:hover {
        color: ${theme.getColor($color)};
      }
    `};
    &:hover {
      ${({ $underlineOnHover }) =>
        $underlineOnHover && `text-decoration: underline`};
    }
    ${({ $nowrap }) => ($nowrap ? ' white-space: nowrap;' : '')}
  }
`;

export default styled(Link)``;
